import template from './companies-detail.html';
import controller from './companies-detail.controller';
import './companies-detail.styl';

const companiesDetailComponent = {
  template,
  controller,
  controllerAs: 'companiesDetail',
  require:{
    app:'^^app'
  }
};

export default companiesDetailComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/companies/companies-detail/companies-detail.component.js
 **/